// src/ThankYou.jsx
import React from "react";

export default function ThankYou() {
  return (
    <main className="min-h-screen flex items-center justify-center p-8">
      <div className="max-w-xl text-center">
        <h1 className="text-3xl font-bold">Thank you! 🎉</h1>
        <p className="mt-3 text-gray-600">
          We’ve sent a confirmation. If you don’t see it, check Spam/Promotions.
        </p>
        <a href="/" className="mt-6 inline-block rounded-2xl bg-black text-white px-5 py-3">
          Back to Home
        </a>
      </div>
    </main>
  );
}
